
<template>
    <div>
      <div class="header" :class="{header_home:$route.path=='/home'}">
        <HeadNav></HeadNav>
      </div>
      <div class="container" :class="{container_home:$route.path=='/home'}">
        <router-view/>
      </div>
      <div class="foot">
        <customFooter class="footer"></customFooter>
      </div>

      <!-- <el-container style="margin:0;padding:0;">
        <div class="header">
          <HeadNav></HeadNav>
        </div>
        <el-main style="margin:0;padding:0;margin-top: 70px;">
          <router-view/>
        </el-main>
        <el-footer style="margin:0;padding:0;">
          <Footer></Footer>
        </el-footer>
      </el-container> -->
    </div>
</template>

<script>
import HeadNav from 'components/header/headNav.vue';
import customFooter from 'components/custom-footer/custom-footer.vue';

    export default {
      components: {
        HeadNav,
        customFooter
      }
    }
</script>

<style lang="less" scoped>
  .header{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 500;
    background: #fff;
  }
  .header_home{
    opacity: 0.71;
  }
  .container{
    margin-top: 60px;
    min-height: calc(100vh - 120px);
    position: relative;
    width: 100%;
    // margin-bottom: 30px;
  }
  .container_home{
    margin-top: 0px;
  }
  .foot{
    // position: fixed;
    // bottom: 0;
    width: 100%;
    // height: 30px;
    // line-height: 30px;
    background-color: #fff;
  }
  // .footer{
  //   position: absolute;
  //   bottom: 0;
  // }
</style>
